module.exports = __webpack_public_path__ + "static/media/Mask.593781df.svg";